@if (iMessageForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="iMessageForm">
          <div class="control-div">
            <input #imageRef [formControlName]="'imageReference'" hidden>
            <select-media [image]="imageRef.value" [imageOnly]="true" (setImageRef)="setImage($event, iMessageForm)">
            </select-media>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Title </label>
            </div>
            <clickatell-form-validation [controlName]="'menuHeader'"
            [form]="iMessageForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="iMessageForm" id="menuHeader"
              [formControlName]="'menuHeader'" placeholder="Enter a title"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Subtitle </label>
              </div>
              <clickatell-form-validation [controlName]="'subtitle'"
              [form]="iMessageForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="iMessageForm" id="subtitle"
                [formControlName]="'subtitle'" placeholder="Enter a subtitle"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Image Title </label>
                </div>
                <clickatell-form-validation [controlName]="'imageTitle'"
                [form]="iMessageForm"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="iMessageForm" id="imageTitle"
                  [formControlName]="'imageTitle'" placeholder="Enter an image title"/>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Image Subtitle </label>
                  </div>
                  <clickatell-form-validation [controlName]="'imageSubtitle'"
                  [form]="iMessageForm"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="iMessageForm" id="imageSubtitle"
                    [formControlName]="'imageSubtitle'" placeholder="Enter an image subtitle"/>
                  </div>
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> App Icon Reference </label>
                    </div>
                    <clickatell-form-validation [controlName]="'appIconReference'"
                    [form]="iMessageForm"></clickatell-form-validation>
                    <input class="control-input" activeForm [activeForm]="iMessageForm" id="appIconReference"
                      [formControlName]="'appIconReference'" placeholder="Enter an app icon reference"/>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> App ID </label>
                      </div>
                      <clickatell-form-validation [controlName]="'appId'"
                      [form]="iMessageForm"></clickatell-form-validation>
                      <input class="control-input" activeForm [activeForm]="iMessageForm" id="appId"
                        [formControlName]="'appId'" placeholder="Enter an app id"/>
                      </div>
                      <div class="control-div">
                        <div class="control-label-container">
                          <label class="control-label"> App Name </label>
                        </div>
                        <clickatell-form-validation [controlName]="'appName'"
                        [form]="iMessageForm"></clickatell-form-validation>
                        <input class="control-input" activeForm [activeForm]="iMessageForm" id="appName"
                          [formControlName]="'appName'" placeholder="Enter an app name"/>
                        </div>
                        <div class="control-div">
                          <div class="control-label-container">
                            <label class="control-label"> Bid </label>
                          </div>
                          <clickatell-form-validation [controlName]="'bid'"
                          [form]="iMessageForm"></clickatell-form-validation>
                          <input class="control-input" activeForm [activeForm]="iMessageForm" id="bid"
                            [formControlName]="'bid'" placeholder="Enter a bid"/>
                          </div>
                          <div class="control-div">
                            <div class="control-label-container">
                              <label class="control-label"> URL </label>
                            </div>
                            <clickatell-form-validation [controlName]="'URL'"
                            [form]="iMessageForm"></clickatell-form-validation>
                            <input class="control-input" activeForm [activeForm]="iMessageForm" id="URL"
                              [formControlName]="'URL'" placeholder="Enter a URL"/>
                            </div>
                            <div class="control-div">
                              <div class="control-label-container">
                                <label class="control-label"> Secondary Subtitle </label>
                              </div>
                              <clickatell-form-validation [controlName]="'secondarySubtitle'"
                              [form]="iMessageForm"></clickatell-form-validation>
                              <input class="control-input" activeForm [activeForm]="iMessageForm" id="secondarySubtitle"
                                [formControlName]="'secondarySubtitle'" placeholder="Enter a secondary subtitle"/>
                              </div>
                              <div class="control-div">
                                <div class="control-label-container">
                                  <label class="control-label"> Tertiary Subtitle </label>
                                </div>
                                <clickatell-form-validation [controlName]="'tertiarySubtitle'"
                                [form]="iMessageForm"></clickatell-form-validation>
                                <input class="control-input" activeForm [activeForm]="iMessageForm" id="tertiarySubtitle"
                                  [formControlName]="'tertiarySubtitle'" placeholder="Enter a tertiary subtitle"/>
                                </div>
                              </ng-container>
                            </ng-container>
                          </clickatell-expansion-panel>
                          <clickatell-expansion-panel>
                            <ng-container header>
                              <mat-panel-title>
                                Logic
                              </mat-panel-title>
                            </ng-container>
                            <ng-container body>
                              <ng-container [formGroup]="iMessageForm">
                                <div class="control-result">
                                  <div class="control-result-header">
                                    Next
                                  </div>
                                  <div class="control-result-container">
                                    <div class="control-div">
                                      <label class="control-label">
                                        <span class="pont-to">Point To</span>
                                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                                      </label>
                                      @if (nodeFlowDetails) {
                                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                                          [selectorType]="'both'"
                                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                          [flows]="nodeFlowDetails.flows"
                                          [name]="'next'"
                                          [form]="iMessageForm"
                                          [stepId]="nodeFlowDetails.stepId">
                                        </next-selector>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                          </clickatell-expansion-panel>
                        </div>
                      }
